import { render, staticRenderFns } from "./restPwPage.vue?vue&type=template&id=0a2b1a7e&scoped=true&"
import script from "./restPwPage.vue?vue&type=script&lang=js&"
export * from "./restPwPage.vue?vue&type=script&lang=js&"
import style0 from "./restPwPage.vue?vue&type=style&index=0&id=0a2b1a7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2b1a7e",
  null
  
)

export default component.exports